export default __webpack_public_path__ + "static/media/sipbooster-home.2748dfb1.png";